import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { ApiService, ABCisApi } from 'src/app/handlers/apiHandler.service';
import { LazyLoadEvent } from 'primeng/api/lazyloadevent';
import { SelectItem } from 'primeng/api/selectitem';
import { ABCisTableModel, ColumnType, LinkType, ColumnData, Dataset, MatchMode } from 'src/app/components/abcis-table/abcis-table.component';
import { ActivatedRoute, Router } from '@angular/router';
import { DocumentHistoryComponent } from './document-history/document-history.component';
import { FormGroup, Validators, FormBuilder, FormControl } from '@angular/forms';
import { FormButton } from 'src/app/components/form-button/form-button.component';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
  selector: 'app-document-status',
  standalone: false,
  templateUrl: './document-status.component.html',
  styleUrls: ['./document-status.component.scss'],
  encapsulation : ViewEncapsulation.None
})

export class DocumentStatusComponent implements OnInit {

  tableConfig: ABCisTableModel;
  priorityForm: FormGroup;

  constructor(private _route: ActivatedRoute,
    private _router: Router,
    private formBuilder: FormBuilder,
    private apiHandler: ApiService) {
    this.priorityForm = this.formBuilder.group({
      priority: ['', Validators.required]
    });
  }

  ngOnInit() {
    this.setConfiguration();
  }

  setConfiguration() {
    this.tableConfig = {
      apiConfig: {
        api: ABCisApi.Support,
        table: 'null',
        url: 'document/status',
        approxamateRowCount: 1000,
        anyParams: true
      },
      colConfig: [
        { field: 'documentId', header: 'Doc ID', type: ColumnType.String, isPrimary: true, isLink: true, width: '8%' },
        { field: 'storeId', header: 'Store', type: ColumnType.MultiSelectComplex, setUrl: 'store/lookup', width: '12%'},
        { field: 'createdAt', header: 'Date', type: ColumnType.Date, width: '10%' },
        { field: 'originalName', header: 'Document Name', type: ColumnType.String, isLink: true, width: '25%' },
        { field: 'jobId', header: 'Job ID', type: ColumnType.DropDown, setUrl: 'job/lookup', width: '10%' },
        { field: 'channelId', header: 'Channel ID', type: ColumnType.DropDown, setUrl: 'channel/lookup', width: '12%' },
        { field: 'ocrStatusId', header: 'Status', type: ColumnType.DropDown, setUrl: 'status/lookup', width: '10%' },
        { field: 'priority', header: 'Priority', type: ColumnType.String, isLink: true, width: '8%' },
        { field: 'documentNumber', header: 'Document Number', type: ColumnType.String, width: '15%' }
      ],
      isConfigurable: false
    };
  }

  rowData: any;
  onLinkClick(event) {
    this.rowData = event.value;
    switch(event.column) {
    case 'documentId':
      this.documentIdOnClick();
      break;
    case 'originalName':
      this.fileViewOnClick();
      break;
    case 'priority':
      this.priorityOnClick();
      break;
    }
  }

  documentNumberEvent: number;
  fileViewValue: string;

  displayModelDocumentId = false;
  displayModelPriority = false;
  displayModelFileView = false;

  documentIdOnClick() {
    this.documentNumberEvent = this.rowData.documentId;
    this.displayModelDocumentId = true;
  }

  fileViewOnClick() {
    this.fileViewValue = this.rowData.fileUuid;
    this.displayModelFileView = true;
  }

  priorityOnClick() {
    this.priorityForm.reset();
    this.priorityButton.setDefault();
    this.priorityForm.get('priority').setValue(this.rowData.priority);
    this.displayModelPriority = true;
  }

  priorityButton: FormButton = new FormButton('Submit');
  prioritySubmit() {
    this.priorityButton.setSubmit('Setting Priority');
    this.apiHandler.postABCisRequest(ABCisApi.Support, `document/${this.rowData.documentId}?priority=${this.priorityForm.value.priority}`).then((value) => {
      this.displayModelPriority = false;
      this.setConfiguration();
    }).catch((error: HttpErrorResponse) => {
      this.priorityButton.setError('Error', error.statusText);
    });
  }

}
